import { Flexbox, Text } from '@morressier/ts';
import { Button, LinkButton } from 'components/ProfileUIComponents';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { getQuery } from 'utils/query';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalImage } from './styles';

const Content = styled(Flexbox)`
  height: 100%;
  overflow-y: auto;
  padding: 32px;
  background-color: var(--color-mono-99);
  text-align: center;
`;

const Container = styled(Flexbox)<{ showExitmessage: boolean }>`
  height: 100%;
  display: ${({ showExitmessage }) => (showExitmessage ? 'block' : 'none')};
`;

const ExitButton = styled(LinkButton)`
  color: var(--color-red-50);
  &:hover,
  &:focus {
    color: var(--color-red-30);
  }
`;

const Description = styled(Text)`
  width: 34rem;
  margin-bottom: 2rem;
`;

interface IEmailValidationViewProps {
  onExit: () => void;
  onBack: () => void;
  showExitmessage: boolean;
}

const EmailValidationView = (props: IEmailValidationViewProps) => {
  const router = useRouter();
  const queryParams = getQuery(router);
  const isAccountActivation = queryParams.flow === 'account-activation';
  const { onExit, onBack, showExitmessage } = props;

  return (
    <Container flexDirection="column" showExitmessage={showExitmessage}>
      <Content
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <ModalImage src="/home-client/shared/svg-exit-warning.svg" />
        <Text size="h3_new" fontWeight="bold">
          Exit without saving?
        </Text>
        <Description>
          {isAccountActivation
            ? "If you exit now, your progress won't be saved. When you return, you'll need to restart account creation from the beginning."
            : 'Your work so far will not be saved for later.'}
        </Description>
        <Flexbox gap="1rem" alignItems="center">
          <Button
            color="secondary"
            onClick={onBack}
            iconBefore={<FontAwesomeIcon icon={faChevronLeft} />}
          >
            Cancel
          </Button>
          <ExitButton
            onClick={onExit}
            {...(isAccountActivation
              ? { href: '/session/logout', as: 'a' }
              : {})}
          >
            <Button color="error">Yes, exit without saving</Button>
          </ExitButton>
        </Flexbox>
      </Content>
    </Container>
  );
};
export default EmailValidationView;
